import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  accordion: {
    marginBottom: 8,
    borderBottomLeftRadius: '20px!important',
    borderBottomRightRadius: '20px!important',
    backgroundColor: theme.palette.background.default
  },
  accordionSummary: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    gap: 5
  }
}))
export default useStyles
